import "./Home.scss"
import Hero from "./Components/Hero/Hero";
import Service from "./Components/OurService/Service";
import Testimonials from "./Components/Testimonials/Testimonials";
import SocialCTA from "./Components/CTA/CTA";


function Home() {
    return (
        <>
            <Hero/>
            <Service />
            <Testimonials/>
            <SocialCTA/>
        </>
    );
}

export default Home;
